module.exports = __webpack_public_path__ + "static/Rosewater6-c734ca2840d3e4d41ab68e2b5e831fce.webp";